import type { FaireProductEntity } from "../../entity_types/product";

export const p_xpyyzvehfy: FaireProductEntity = {
  token: "p_xpyyzvehfy",
  type: "product",
  name: "18k Crafted Gold Herringbone Flat Chain 18\"",
  brandToken: "b_tv8s4823nu",
  brandName: "FASHIONISTAAA",
  imageUrl: "https://cdn.faire.com/fastly/2d81d8c9f75cc472b85f181d1fda9f2c5df42780311f73b93a9f383fd0abe5e6.jpeg",
  galleryImageUrls: [],
  priceDollars: 6,
  description: "Fashionista Fashionista 18k Crafted Gold filled Herringbone Flat Chain 18''Fashionista Fashionista You will love to get all tangle up in this Flat chain necklace. Crafted in gold plated brass, this necklace features. Guaranteed to retain its original gold content and color. The perfect complement to any outfit.Fashionista Fashionista Weight (lbs.):0.03Fashionista Length (in.):0.7Fashionista Width (in.):0.4Fashionista Height (in.):0.3Fashionista .",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:16.481Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
